module.exports = __webpack_public_path__ + "img/github.ee760804.svg";